// 200829
export default {
  translation: {
    sections: {
      introduction: 'introducción',
      gallery: 'galería',
      skills: 'técnicas',
      'about-me': 'sobre mí',
      contact: 'contacto',
    },
    aboutMeTextData: [
      [
        'Me llamo Kevin. Soy un desarrollador de red/móvil specializado en React/Redux, React y la pila MERN.',
        'Actualmente estoy trabajando como desarrollador móvil.',
        'Mi objetivo es conseguir un trabajo remoto en Barcelona o un trabajo remoto que me permita trabajar desde allá.'
      ],
      [
        'Comencé mi viaje de codificación de alta tecnología en INTEL, fabricando chips de computadora en una sala blanca de I&D líder.',
        'Allí realicé bastantes trabajos de programación y llevé muchas clases de programación mientras estudiaba ingeniería eléctrica.',
        'En la escuela secundaria también estudié Basic y Pascal.',
        'Para mi trabajo de programación, empecé con Pascal, luego me enseñé C, y utilicé bastante este language.',
        'En la universidad, estudié mucho de C, y algo de COBOL, Fortran y assembly.',
        'Cuando en este trabajo, basado en las necesidade del departamento, escribé dos programas por lo que gané un premio y una bonificación.',
        'Una de las cosas por las cuales me siento orgulloso en mi vida profesional de programador es que esos programas siguen siendo utilizados, casi una década más tarde.',
      ],
      [
        'Decidí que necesitaba un trabajo más estable, así es que regresé a mis orígenes de programamador.',
        'Eventualmente obtuve un Másters en música y he tenido una carrera muy divertida, pero extrañaba el trabajo de programación así es que continué trabajando en algunos proyectocitos. ',
      ],
      [
        'Decidiendo que necesitaba una carrera más estable, volví a mis raíces de programación.',
        'En 2016 empecé el curso de Free Code Camp y completé la certificación en Front End Development, Data Visualization y Back End Development.',
        'Sigo siendo un moderador activo y un mentor en su foro y al mismo tiempo contribuyo con su código base y con otros proyectos de código abierto.',
      ],
      [
        'En la actualidad estoy trabajando como ingeniero de sofware de nivel III para una gran compañía de camiones (JB Hunt), ayudando a un equipo grande y diverso a desarrollar una aplicación galardonada de React Native.',
        'Dentro del gran equipo, dirijo a un equipo pequeño y soy un firme defensor de la calidad del código, mejores practicas y pruebas.',
      ],
      [
        'Si bien me gusta la empresa y mis compañeros de trabajo, mi esposa y yo soñamos con vivir en Barcelona.',
        'Desafortunadamente, mi trabajo actual no nos ayudará a lograr este objetivo, así es que estoy abierto a nuevas oportunidades.',
      ],
    ],
    introductionTextData: [
      [
        'Soy un desarrollador red/móviles especializado en React, Redux, React Native y el MERN stack.'
      ],
      [
        'Soy de los Estados Unidos, pero mi próximo trabajo o será basado en Barcelona o me permitirá trabajar remotamente desde allá.',
      ],
    ],
    skills: {
      sections: {
        frontend: 'Front End',
        backend: 'Back End',
        other: 'Otro',
        past: 'Pasado',
      },
      text: [
        [
          "Me encanta aprender nuevas bibliotecas y tecnologías, así que esta lista está cambiando constantemente - no tenga miedo de preguntar.",
        ],
        [
          "En mi vida pasada como programador y entonces aficionado, también he trabajado con Pascal, C, assembly, Fortran, COBOL, PHP, Basic, and VBA, y he incursionado en C++ y Java.",
        ],
      ],
    },
  },
};
